// import local dependencies
import Router from './util/Router';
import common from './multisite/routes/common';
import home from './multisite/routes/home';
import singleArticle from './multisite/routes/singleArticle';
import archive from './multisite/routes/archive';
import singleTestPostType from './multisite/routes/singleTestPostType';
import templateCategoryLanding from './multisite/routes/templateCategoryLanding';
import templateFaq from './multisite/routes/templateFaq';
import templateEditorial from './multisite/routes/templateEditorial';
import templateContactUs from './multisite/routes/templateContactUs';
import search from './multisite/routes/search';
import templateBrowse from './multisite/routes/templateBrowse';
import singleHomeProduct from './multisite/routes/singleHomeProduct';
import singleKitchenProduct from './multisite/routes/singleKitchenProduct';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Single Article
  singleArticle,
  // Taxonomy
  archive,
  // Category Landing, same as Taxonomy
  templateCategoryLanding,
  // FAQ Page / modules.
  templateFaq,
  // Editorial Page Template
  templateEditorial,
  // Contact us form
  singleTestPostType,
  templateContactUs,
  // Search Page
  search,
  // Browse Template
  templateBrowse,
  // single home product
  singleHomeProduct,
  // single kitchen product
  singleKitchenProduct,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite.js